import { render } from "./index.vue?vue&type=template&id=1f2a011c"
import script from "./my-leagues.ts?vue&type=script&lang=js"
export * from "./my-leagues.ts?vue&type=script&lang=js"

import "./my-leagues.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script